import type {
  AdContext,
  AdInsertionRule,
  PlacementWithoutPosition,
} from '../types/ad-types.js';

import { ContentType, PageType } from '../types/ad-types.js';

const frontpagePlacements = {
  desktop: [
    {
      targetId: 'takeover',
      invCode: 'no-vink-wde-front_topscroller',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['topscroller'],
      },
      sizes: [[4, 4]],
    },
    {
      targetId: 'netboard_1',
      invCode: 'no-vink-wde-front_netboard_1',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_1'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_2',
      invCode: 'no-vink-wde-front_netboard_2',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_2'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_3',
      invCode: 'no-vink-wde-front_netboard_3',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_3'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_4',
      invCode: 'no-vink-wde-front_netboard_4',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_4'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_5',
      invCode: 'no-vink-wde-front_netboard_5',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_5'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'brandboard_1',
      invCode: 'no-vink-wde-front_brandboard_1',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_1'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'brandboard_2',
      invCode: 'no-vink-wde-front_brandboard_2',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_2'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'brandboard_3',
      invCode: 'no-vink-wde-front_brandboard_3',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_3', 'fullscreen'],
      },
      sizes: [
        [1920, 1080],
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'brandboard_4',
      invCode: 'no-vink-wde-front_brandboard_4',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_4'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'brandboard_5',
      invCode: 'no-vink-wde-front_brandboard_5',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_5'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'brandboard_6',
      invCode: 'no-vink-wde-front_brandboard_6',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_6'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'sponsorstripe',
      invCode: 'no-vink-wde-front_sponsorstripe',
      allowedFormats: ['native'],
      keywords: {
        'no-sno-adformat': ['sponsorstripe'],
      },
      sizes: [[1, 1]],
    },
  ],
  tablet: [],
  mobile: [
    {
      targetId: 'takeover',
      invCode: 'no-vink-wph-front_topscroller',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['topscroller'],
      },
      sizes: [[4, 4]],
    },
    {
      targetId: 'board_1',
      invCode: 'no-vink-wph-front_board_1',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_1'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_2',
      invCode: 'no-vink-wph-front_board_2',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_2'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_3',
      invCode: 'no-vink-wph-front_board_3',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_3', 'fullscreen'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
        [1920, 1080],
      ],
    },
    {
      targetId: 'board_4',
      invCode: 'no-vink-wph-front_board_4',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_4'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_5',
      invCode: 'no-vink-wph-front_board_5',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_5'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_6',
      invCode: 'no-vink-wph-front_board_6',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_6'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_7',
      invCode: 'no-vink-wph-front_board_7',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_7'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_8',
      invCode: 'no-vink-wph-front_board_8',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_8'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_9',
      invCode: 'no-vink-wph-front_board_9',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_9'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'sponsorstripe',
      invCode: 'no-vink-wph-front_sponsorstripe',
      allowedFormats: ['native'],
      keywords: {
        'no-sno-adformat': ['sponsorstripe'],
      },
      sizes: [[1, 1]],
    },
  ],
};

const articlePlacements = {
  desktop: [
    {
      targetId: 'takeover',
      invCode: 'no-vink-wde-article_topscroller',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['topscroller'],
      },
      sizes: [[4, 4]],
    },
    {
      targetId: 'netboard_1',
      invCode: 'no-vink-wde-article_netboard_1',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_1'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_2',
      invCode: 'no-vink-wde-article_netboard_2',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_2'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_3',
      invCode: 'no-vink-wde-article_netboard_3',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_3'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_4',
      invCode: 'no-vink-wde-article_netboard_4',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_4'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_5',
      invCode: 'no-vink-wde-article_netboard_5',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_5'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_6',
      invCode: 'no-vink-wde-article_netboard_6',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_6'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'netboard_7',
      invCode: 'no-vink-wde-article_netboard_7',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['netboard_7'],
      },
      sizes: [
        [580, 400],
        [580, 500],
      ],
    },
    {
      targetId: 'brandboard_1',
      invCode: 'no-vink-wde-article_brandboard_1',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_1'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'brandboard_2',
      invCode: 'no-vink-wde-article_brandboard_2',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_2'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'brandboard_3',
      invCode: 'no-vink-wde-article_brandboard_3',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['brandboard_3'],
      },
      sizes: [
        [980, 300],
        [980, 500],
        [980, 600],
      ],
    },
    {
      targetId: 'sponsorstripe',
      invCode: 'no-vink-wde-article_sponsorstripe',
      allowedFormats: ['native'],
      keywords: {
        'no-sno-adformat': ['sponsorstripe'],
      },
      sizes: [[1, 1]],
    },
  ],
  tablet: [],
  mobile: [
    {
      targetId: 'takeover',
      invCode: 'no-vink-wph-article_topscroller',
      allowedFormats: ['banner'],
      keywords: {
        'no-sno-adformat': ['topscroller'],
      },
      sizes: [[4, 4]],
    },
    {
      targetId: 'board_1',
      invCode: 'no-vink-wph-article_board_1',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_1'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_2',
      invCode: 'no-vink-wph-article_board_2',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_2'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_3',
      invCode: 'no-vink-wph-article_board_3',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_3', 'fullscreen'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
        [1920, 1080],
      ],
    },
    {
      targetId: 'board_4',
      invCode: 'no-vink-wph-article_board_4',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_4'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_5',
      invCode: 'no-vink-wph-article_board_5',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_5'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_6',
      invCode: 'no-vink-wph-article_board_6',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_6'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_7',
      invCode: 'no-vink-wph-article_board_7',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_7'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'board_8',
      invCode: 'no-vink-wph-article_board_8',
      allowedFormats: ['banner', 'native'],
      keywords: {
        'no-sno-adformat': ['board_8'],
      },
      sizes: [
        [320, 250],
        [320, 400],
        [5, 400],
      ],
    },
    {
      targetId: 'sponsorstripe',
      invCode: 'no-vink-wph-article_sponsorstripe',
      allowedFormats: ['native'],
      keywords: {
        'no-sno-adformat': ['sponsorstripe'],
      },
      sizes: [[1, 1]],
    },
  ],
};

const adInsertionRules: Record<Exclude<AdContext, 'list'>, AdInsertionRule> = {
  frontpage: {
    count: [
      ContentType.BUNDLE,
      ContentType.CHUNK,
      ContentType.FULL_WIDTH_TEASER,
    ],
    interval: 2,
    anchorBefore: false,
    pageType: PageType.FRONTPAGE,
  },
  section: {
    count: [
      ContentType.BUNDLE,
      ContentType.CHUNK,
      ContentType.FULL_WIDTH_TEASER,
    ],
    interval: 2,
    anchorBefore: false,
    pageType: PageType.ARTICLE,
  },
  review: {
    countExcept: [ContentType.IMAGE],
    interval: 6,
    anchorBefore: false,
    pageType: PageType.ARTICLE,
  },
  guide: {
    countExcept: [ContentType.IMAGE],
    interval: 5,
    anchorBefore: false,
    pageType: PageType.ARTICLE,
  },
};

const listPositionConfig: Record<string, Record<string, number | null>> = {
  desktop: {
    netboard_1: 6,
    netboard_2: 13,
    netboard_4: 20,
    netboard_5: 24,
    netboard_3: null,
  },
  mobile: {
    board_1: 6,
    board_2: 13,
    board_3: 20,
    board_4: 27,
    board_5: 36,
  },
};

const getSlotPool = (
  pageType: PageType,
  device: string,
): PlacementWithoutPosition[] => {
  if (pageType === PageType.FRONTPAGE) {
    return (
      (frontpagePlacements as Record<string, PlacementWithoutPosition[]>)[
        device
      ] ?? []
    );
  }

  return (
    (articlePlacements as Record<string, PlacementWithoutPosition[]>)[device] ??
    []
  );
};

const getListPlacements = (
  device: string,
): (PlacementWithoutPosition & { position: number | null })[] => {
  const placements =
    (articlePlacements as Record<string, PlacementWithoutPosition[]>)[device] ??
    [];
  const positionMap = listPositionConfig[device] ?? {};

  return placements.map((item) => ({
    ...item,
    position: positionMap[item.targetId] ?? null,
  }));
};

export {
  frontpagePlacements,
  articlePlacements,
  adInsertionRules,
  getSlotPool,
  getListPlacements,
};
